import { render, staticRenderFns } from "./SendMailButton.vue?vue&type=template&id=63a3a5c7"
import script from "./SendMailButton.vue?vue&type=script&lang=ts"
export * from "./SendMailButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports